// hooks/useClientAuth.ts
import { useEffect, useState } from "react";
import { useMyProviderDataClient } from "../../../../context/ApiContext";

export const useClientAuth = (clientId?: number | null) => {
  const client = useMyProviderDataClient();
  const [data, setData] = useState<string[][]>();
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    if (!clientId) return;

    const load = async () => {
      setLoading(true);

      const res = await client.get(
        "/EmployeeInformation/ClientUtilizationAuth",
        { params: { clientid: clientId } }
      );

      const formatted = res.data.map((d: any) => {
        const start = new Date(d["Authorization Start Date"]);
        const end = new Date(d["Authorization End Date"]);

        return [
          d["Insurance Company Name"],
          start.toLocaleDateString(),
          end.toLocaleDateString(),
          String(d["Authorization ID"]),
          d["Billing Code"],
          String(d["Total Hours"]),
          String(d["Total Hours Used to Date"]),
          String(d["Days Remaining on Auth"]),
        ];
      });

      setData(formatted);
      setLoading(false);
    };

    load();
  }, [clientId, client]);

  return { data, loading };
};